module.exports = __webpack_public_path__ + "static/media/banner_reourceforyou-Parents-Training_Workshop.3f87039e.png";